import { CancelToken } from 'axios';
import { awModelManagementApi } from '../Base';
import {
  AGraphCreateModelPayload,
  AgraphModelVersionHistoryPayload,
  AgraphModelVersionHistoryResponse,
  AGraphNewModel,
  AGraphPatchModelPayload,
  AgraphSearchTypeaheadPayload,
  AgraphSearchTypeaheadResponse,
} from './types';

export const BASE_MODELS_PATH = 'models/v1/models';

export function createNewModel(payload: AGraphCreateModelPayload) {
  return awModelManagementApi.post<AGraphNewModel>(BASE_MODELS_PATH, payload, { params: { pkg: payload.pkg } });
}

export function searchTypeaheadModel(payload: AgraphSearchTypeaheadPayload, cancelToken?: CancelToken) {
  const path = `${BASE_MODELS_PATH}:search`;
  return awModelManagementApi.post<AgraphSearchTypeaheadResponse>(path, payload, {
    params: { pkg: payload.pkg },
    cancelToken,
  });
}

export function getModel(id: string, pkg: string, includePositions: boolean, cancelToken?: CancelToken) {
  const path = `${BASE_MODELS_PATH}/${id}`;
  return awModelManagementApi.get<AGraphNewModel>(path, { params: { pkg, includePositions }, cancelToken });
}

export function deleteModel(id: string, pkg: string) {
  const path = `${BASE_MODELS_PATH}/${id}`;
  return awModelManagementApi.delete<void>(path, { params: { pkg } });
}

export function patchModel(id: string, payload: AGraphPatchModelPayload) {
  const path = `${BASE_MODELS_PATH}/${id}`;
  return awModelManagementApi.patch<AGraphNewModel>(path, payload, { params: { pkg: payload.pkg } });
}

export function getModelVersionHistoryApi(payload: AgraphModelVersionHistoryPayload, signal?: AbortSignal) {
  const { modelId, pkg, startDate, endDate, nextPageToken } = payload;
  const path = `${BASE_MODELS_PATH}/${modelId}/positionVersions`;
  const params = {
    pkg,
    ...(startDate && { 'filterQuery.startDate': startDate }),
    ...(endDate && { 'filterQuery.endDate': endDate }),
    ...(nextPageToken && { pageToken: nextPageToken }),
  };

  if (startDate) {
    params['filterQuery.startDate'] = startDate;
  }
  if (endDate) {
    params['filterQuery.endDate'] = endDate;
  }
  if (nextPageToken) {
    params.pageToken = nextPageToken;
  }

  return awModelManagementApi.get<AgraphModelVersionHistoryResponse>(path, { params, signal });
}
